var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFigma(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 32,
    viewBox: "0 0 32 32",
    width: 32,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m32 5c0-2.76142-2.2386-5-5-5h-22c-2.76142 0-5 2.23858-5 5v22c0 2.7614 2.23858 5 5 5h22c2.7614 0 5-2.2386 5-5z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m15.9834 16c0-1.4727 1.1939-2.6667 2.6666-2.6667 1.4728 0 2.6667 1.194 2.6667 2.6667 0 1.4728-1.1939 2.6667-2.6667 2.6667-1.4727 0-2.6666-1.1939-2.6666-2.6667z",
    fill: "#1abcfe"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m10.65 21.3333c0-1.4727 1.1939-2.6666 2.6667-2.6666h2.6667v2.6666c0 1.4728-1.1939 2.6667-2.6667 2.6667s-2.6667-1.1939-2.6667-2.6667z",
    fill: "#0acf83"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m15.9834 8v5.3333h2.6666c1.4728 0 2.6667-1.1939 2.6667-2.6666 0-1.47279-1.1939-2.6667-2.6667-2.6667z",
    fill: "#ff7262"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m10.65 10.6667c0 1.4727 1.1939 2.6666 2.6667 2.6666h2.6667v-5.3333h-2.6667c-1.4728 0-2.6667 1.19391-2.6667 2.6667z",
    fill: "#f24e1e"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m10.65 16c0 1.4728 1.1939 2.6667 2.6667 2.6667h2.6667v-5.3334h-2.6667c-1.4728 0-2.6667 1.194-2.6667 2.6667z",
    fill: "#a259ff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigma);
export default __webpack_public_path__ + "static/media/figma.5580ee5d6e639bcc3c07b264f6c28dc1.svg";
export { ForwardRef as ReactComponent };